import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { deserializeFicheDePreps } from '@teetsh/app/src/queries/sequences/serializer';

export function getStandaloneFicheDePrep(ficheDePrepId?: string) {
  if (!ficheDePrepId) {
    throw new Error('Missing ficheDePrepId');
  }

  return request(`/fiches-de-prep/${ficheDePrepId}`, {
    method: 'GET',
  }).then(res => deserializeFicheDePreps(res));
}

export const standaloneFdpQueryKeys = {
  detail: (ficheDePrepId?: string) => ['standalone-fdp', ficheDePrepId],
};

export default function useStandaloneFicheDePrep(ficheDePrepId?: string) {
  return useQuery({
    queryKey: standaloneFdpQueryKeys.detail(ficheDePrepId),
    queryFn: () => getStandaloneFicheDePrep(ficheDePrepId),
    refetchOnWindowFocus: true,
    enabled: !!ficheDePrepId,
  });
}
